import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Claim } from '@amfam/claim/data-access';
import { Address, Vehicle } from '@amfam/policy/models';

@Component({
  selector: 'app-claim-risk',
  templateUrl: './claim-risk.component.html',
  standalone: false
})
export class ClaimRiskComponent implements OnChanges {
  @Input() claim: Claim;
  vehicle: Vehicle;
  address: Address;
  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    this.address = null;
    this.vehicle = null;
    if (this.claim) {
      if (this.claim.autoClaimDetails && this.claim.autoClaimDetails.length > 0) {
        this.vehicle = this.claim.autoClaimDetails[0];
      } else {
        this.address = this.claim.lossLocationAddress;
      }
    }
  }
}
